import {
    ChainInfo,
    DailyTokenStats,
    OracleQuote,
    OrderBook,
    SwapData,
    TokenInfo,
} from '../types';

const API = '/api';

async function getJson<T>(path: string): Promise<T> {
    const r = await fetch(`${API}${path}`);
    if (!r.ok) throw new Error(`${path}: ${r.status} ${r.statusText}`);
    return r.json();
}

export const api = {
    health: () => getJson<{ status: string; chains: string[]; default_chain: string }>('/health'),

    chains: () => getJson<{ chains: ChainInfo[] }>('/chains').then((r) => r.chains),

    coins: (chain?: string) =>
        getJson<{ chain: string; coins: TokenInfo[] }>(
            `/coins${chain ? `?chain=${chain}` : ''}`
        ).then((r) => r.coins),

    orderBook: (token: string, chain?: string) =>
        getJson<{ orderBook: OrderBook }>(
            `/orderbook/${token}${chain ? `?chain=${chain}` : ''}`
        ).then((r) => r.orderBook),

    oracles: (chain?: string) =>
        getJson<{ quotes: OracleQuote[] }>(
            `/oracles${chain ? `?chain=${chain}` : ''}`
        ).then((r) => r.quotes),

    recentTrades: (chain?: string, limit = 100) =>
        getJson<{ trades: SwapData[] }>(
            `/trades?limit=${limit}${chain ? `&chain=${chain}` : ''}`
        ).then((r) => r.trades),

    stats: (chain?: string) =>
        getJson<{ stats: DailyTokenStats[] }>(
            `/stats${chain ? `?chain=${chain}` : ''}`
        ).then((r) => r.stats),
};
